import React, { useEffect, useState } from "react";

import dataSharingImage from "../../../Images/sharing-data-new.jpg";
import { CancelContinueButtons } from "../../Controls/CancelContinueButtons";
import { useStore } from "../../../Store";
import { PageLayoutWithGetData } from "../../Controls/PageLayout";
import Helpers from "../../Functions/Helpers";
import { useNavigate } from "react-router-dom";
import { AxiosRequestConfig } from "axios";
import {
  Box,
  Center,
  Divider,
  Heading,
  Icon,
  Image,
  List,
  ListItem,
  Text,
} from "@chakra-ui/react";
import { FaSquareFull } from "react-icons/fa";
import { ConsumerDataRightBox } from "../../Controls/ConsumerDataRightBox";

export default function ValueProposition() {
  const navigate = useNavigate();

  const {
    token,
    data,
    setData,
    setLoading,
    setShowPopup,
    setShowPopupError,
    setPopupErrorMessage,
    sessionDetails,
  } = useStore();

  const [dataRecipient, setDataRecipient] = useState(
    data?.softwareProduct?.dataRecipientBrand?.dataRecipient
  );
  const [softwareProductWording, setSoftwareProductWording] = useState(
    data?.softwareProductWording
  );

  useEffect(() => {
    function GetData() {
      const config: AxiosRequestConfig = {
        method: "get",
        url:
          process.env.REACT_APP_PUBLIC_API_BASE_URI +
          "/portal/consent/" +
          sessionDetails?.consentId,
        headers: {
          "session-id": sessionDetails?.sessionId,
          Authorization: "Bearer " + token?.access_token,
        },
      };

      Helpers.CallApi(
        config,
        (response) => {
          // handle success
          let responseData = response?.data?.data;
          setData(responseData);
          setDataRecipient(
            responseData?.softwareProduct?.dataRecipientBrand?.dataRecipient
          );
          setSoftwareProductWording(responseData?.softwareProductWording);

          setLoading(false);
          
          if(responseData?.session?.startPage === "data-request") {
            navigate("/DataRequest");
          }
        },
        (message) => {
          // handle error
          handleError(message);
        }
      );
    }

    GetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleError(message: string) {
    setLoading(false);
    setShowPopup(false);
    setShowPopupError(true);
    setPopupErrorMessage(message);
  }

  return (
    <PageLayoutWithGetData>
      <Heading variant="pageHeading">Provide Your Information</Heading>

      <Text>{softwareProductWording?.paragraphProvideYourInformation}</Text>

      <Center>
        <Image
          w="70%"
          id="ValuePropImage"
          src={dataSharingImage}
          alt="Value proposition page logo"
        />
      </Center>

      <Heading fontSize="md" mb={4}>
        Share data with the Consumer Data Right
      </Heading>

      <Box pb={3}>
        <Text>
          You can connect us with your bank via the Consumer Data Right.This
          option is quick accurate and can save you time by providing us with
          correct information.
        </Text>

        <ConsumerDataRightBox dataRecipient={dataRecipient} />

        <Text mb={4}>
          We are an Accredited Consumer Data Right Recipient, meaning we are
          bound by rules set by the Australian Government on how we can handle
          your data.
        </Text>

        <Text>
          Learn more about this{" "}
          <a
            href={dataRecipient?.acccCdrProviderSearchUri}
            aria-label={dataRecipient?.acccCdrProviderSearchUri || "N/A"}
            target="_blank"
            rel="noreferrer"
          >
            here
          </a>
        </Text>

        <Divider my={4} />

        <Heading fontSize="sm" mb={4}>
          Key things you should know
        </Heading>

        <List spacing={3} mb={6}>
          {softwareProductWording?.paragraphThingsYouShouldKnow?.map(
            (item: any, index: number) => (
              <ListItem key={index} display="flex">
                <Icon
                  mt="4px"
                  as={FaSquareFull}
                  color="blue.500"
                  w={3}
                  h={3}
                  mr={"10px"}
                />
                <Text>{item}</Text>
              </ListItem>
            )
          )}
        </List>

        <Text>
          Find out more information on how we handle your data in our easy to
          read{" "}
          <a
            href={dataRecipient?.consumerDataRightsPolicyUri || ""}
            aria-label={dataRecipient?.consumerDataRightsPolicyUri || "N/A"}
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            Consumer Data Right policy{" "}
          </a>
        </Text>
      </Box>

      <CancelContinueButtons
        OnclickContinue={() => navigate("/DataSharingInstructions")}
        btnContinueText="Start"
        step="ValueProposition"
      />
    </PageLayoutWithGetData>
  );
}
